import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import tradedesk1 from './pictures/tradedesk2.jpeg';

const Trade = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC x Trade Desk: Secrets to Your Summer Internship Event</h2>
                    <p class="site-post-meta">April 16, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                     
                    Thank you to everyone who attended our WiC x Trade Desk: Secrets to Your Summer Internship event on April 16!

                    Attendees gained several insights about tips for succeeding in an internship, what questions to ask and when, how to confidently secure a return offer. It was great hearing from Trade Desk recruiter Kim and Rachel about their experience at the Trade Desk and in industry! 
                    </p>
                    <img src={tradedesk1} alt="pic1 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Trade;
